import { useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { useImFeature } from '../im/ImFeatureProvider';
import { useMiniChat } from './MiniChatProvider';
import MiniChatLauncher from './MiniChatLauncher';
import MiniChatWindow from './MiniChatWindow';
import './mini-chat.css';

/**
 * Floating Mini Chat UI. Requires MiniChatProvider (App) + ChatProvider.
 * Hidden on Full Chat routes (`/chat*`).
 * FAB「聊」只受 chat.enabled；進行中的客服 mini 視窗仍可顯示。
 */
export default function MiniChatRoot() {
  const { isAuthenticated } = useAuth();
  const { chatEnabled } = useImFeature();
  const { slots } = useMiniChat();
  const location = useLocation();
  const onFullChat = location.pathname.startsWith('/chat');

  if (!isAuthenticated || onFullChat) {
    return null;
  }

  const supportSlots = slots.filter((s) => s.support);
  const socialSlots = chatEnabled ? slots.filter((s) => !s.support) : [];
  const visibleSlots = [...supportSlots, ...socialSlots];
  const expanded = visibleSlots.filter((s) => !s.minimized);
  const minimized = visibleSlots.filter((s) => s.minimized);
  const showFab = chatEnabled;

  if (!showFab && visibleSlots.length === 0) {
    return null;
  }

  return (
    <div className="mini-chat-root" aria-live="polite">
      <div className="mini-chat-windows">
        {expanded.map((s) => (
          <MiniChatWindow
            key={s.conversationId}
            conversationId={s.conversationId}
            minimized={false}
            support={!!s.support}
            supportSessionId={s.supportSessionId}
            supportStatus={s.supportStatus}
          />
        ))}
      </div>
      <div className="mini-chat-dock">
        {minimized.map((s) => (
          <MiniChatWindow
            key={`min-${s.conversationId}`}
            conversationId={s.conversationId}
            minimized
            support={!!s.support}
            supportSessionId={s.supportSessionId}
            supportStatus={s.supportStatus}
          />
        ))}
        {showFab ? <MiniChatLauncher /> : null}
      </div>
    </div>
  );
}
